import { httpClient } from '../http/httpClient'

export interface SupportTeamMember {
  id: string
  name: string
}

export const getSupportTeam = async () => {
  const { data } = await httpClient.get<SupportTeamMember[]>(
    '/support-requests/team',
  )
  return data
}
